module.exports = __webpack_public_path__ + "images/category_lp/common/medal-flat@2x_978a363b81159a713c8e3ad68c1ed98c.png";